// import stand lib
import React, { useState, useContext } from "react";
import MenuProvider from "../framework/MenuProvider";
import Header from "../framework/Header";
import {
  Route,
  Switch,
 // withRouter,
  BrowserRouter as Router,
 // Redirect
} from "react-router-dom";
import { AppConfiguration } from "../framework/AppConfigProvider";

// import conponents from components folder
//import TopNav from "../framework/TopNav";
import navigation from "./Navigation";

const Layout = (props) => {
  	console.log("Layout:", props);
  // Using Context Provider
  // share same context (ShowMenu) for the child and for the parent component.
  const [ShowMenu, setMenu] = useState(false);

  // this is for the header, call open the menu
  const showMenu = () => {
    setMenu(true);

  };

  // this is for the menu, any click will close the menu
/*  const hideMenu = () => {
    setMenu(false);

  };
*/
  //Retrieve and display user profile info from the context.
  const localConfig = useContext(AppConfiguration);
  console.log("Layout.js:", localConfig);

  return (
    <div>
      <MenuProvider.Provider value={ShowMenu}>
        <Router>
          <Header
            longTitle={localConfig.configProperties.applicationName}
            shortTitle={localConfig.configProperties.applicationNameAbbrev}
            handleMouseUp={showMenu}
            userName={""}
          />
          <article>
            <div className="container">
              <Switch>
                {navigation.map(({ to, component, allowAccess, needExact }, i) => (
                 <Route
		              key={i}
		              path={to}
		              render={(renderProps) => {
						const Component = component;
	                        return <Component {...props}  {...renderProps}/>;                       
                      }}
		              exact={needExact}
		            />
                ))}

                
              </Switch>
            </div>
          </article>
        </Router>
      </MenuProvider.Provider>
    </div>
  );
};

export default Layout;